/**
 * Dev Utilities Service
 *
 * Central service for development utilities.
 * Provides region detection and utility functions.
 */

import { AppConfig } from '~/services/app-config-service';

/**
 * Detect if we're in a development environment
 */
export function isDevRegion(): boolean {
  return import.meta.env.DEV || AppConfig.isLocal;
}

/**
 * Get the current region name
 */
export function getRegionName(): 'DEV' | 'PRODUCTION' {
  return isDevRegion() ? 'DEV' : 'PRODUCTION';
}
